import { Loader2Icon } from "lucide-react";
import * as React from "react";

import { cn } from "@/lib/utils";

const SpinnerComponent = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>((props, ref) => {
  const { className, ...rest } = props;

  return (
    <Loader2Icon
      ref={ref}
      className={cn("animate-spin", className)}
      {...rest}
    />
  );
});

SpinnerComponent.displayName = "Spinner";

export const Spinner = React.memo(SpinnerComponent);
